import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { PRODUCTS } from "@/data/products";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ProductsContext = createContext({ products: PRODUCTS, source: "placeholder" });

const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

const FAMILY_WORDS = /^(floral|woody|woods|ambery|amber|spicy|spice|fresh|citrus|oud|leather|leathery|gourmand|musky|musk|smoky|smokey|sweet|tobacco|aromatic|foug[eè]re|chypre|oriental|green|aquatic|marine|powdery|fruity|vanilla|rose|resinous|balsamic|earthy|animalic|herbal|mossy|aldehydic|honeyed|boozy|incense|saffron|iris|sandalwood|cedar|vetiver|patchouli|jasmine|tuberose|neroli|bergamot|lavender|tonka|praline|caramel|coffee|cacao|cocoa|tea|mineral|ozonic|solar|warm|dark|creamy|velvety|rich)$/i;
const cleanTags = (tags = []) =>
  tags.map((t) => (t || "").trim()).filter((t) => FAMILY_WORDS.test(t)).map((t) => t.replace(/^\w/, (c) => c.toUpperCase())).slice(0, 4);

const merge = (shopifyList, bestseller) => {
  return PRODUCTS.map((p) => {
    const s = shopifyList.find((sp) => sp.handle === p.slug || sp.normalized_title === norm(p.name));
    const base = { ...p, bestseller: p.slug === bestseller };
    if (!s) return { ...base, available: true };
    return {
      ...base,
      name: s.title || p.name,
      description: s.description || p.description,
      image: s.image || p.image,
      images: s.images?.length ? s.images : [],
      families: cleanTags(s.tags).length ? cleanTags(s.tags) : p.families,
      isNew: (s.tags || []).some((t) => /^new$/i.test(t)),
      shopifyUrl: s.url || p.shopifyUrl,
      buyUrl: s.url || p.buyUrl,
      price50: s.price50 ?? p.price50,
      price10: s.price10 ?? p.price10,
      priceCombo: s.priceCombo ?? null,
      available: s.available,
      live: true,
    };
  });
};

export const ProductsProvider = ({ children }) => {
  const [state, setState] = useState({ products: PRODUCTS.map((p) => ({ ...p, available: true })), source: "placeholder" });

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => {
        if (res.data.source === "shopify" && res.data.products.length) {
          setState({ products: merge(res.data.products, res.data.bestseller), source: "shopify" });
        } else if (res.data.bestseller) {
          setState((prev) => ({ ...prev, products: prev.products.map((p) => ({ ...p, bestseller: p.slug === res.data.bestseller })) }));
        }
      })
      .catch(() => {});
  }, []);

  return <ProductsContext.Provider value={state}>{children}</ProductsContext.Provider>;
};

export const useProducts = () => useContext(ProductsContext);
